import { Vue, Component } from 'vue-property-decorator'
import pedidos from '@/store/modules/PedidoModule'

@Component
export default class PedidoPage extends Vue {
  headers = [
    {
      text: 'Codigo',
      value: 'id'
    },
    {
      text: 'Fecha',
      value: 'fecha'
    },
    {
      text: 'Nombre / Razon Social',
      value: 'cliente_nombre'
    },
    {
      text: 'DNI / RUC',
      value: 'cliente_documento'
    },
    {
      text: 'Dirección',
      value: 'cliente_direccion'
    },
    {
      text: '...',
      value: 'actions'
    }
  ]

  openDetalle = false

  headersDetail = [
    {
      text: 'Codigo',
      value: 'codigo_sistema'
    },
    {
      text: 'Articulo',
      value: 'nombre'
    },
    {
      text: 'Cantidad',
      value: 'cantidad',
      align: 'end'
    },
    {
      text: 'Unidad Medida',
      value: 'unidad_medida'
    },
    {
      text: 'Precio',
      value: 'precio',
      align: 'end'
    },
    {
      text: 'Importe',
      value: 'importe',
      align: 'end'
    },
    {
      text: 'Detalle',
      value: 'detalle'
    }
  ]

  desdeOpen = false
  desde = new Date().toISOString().substr(0, 10)
  hastaOpen = false
  hasta = new Date().toISOString().substr(0, 10)

  get items () {
    return pedidos.items
  }

  get itemsDetail () {
    return pedidos.itemsDetail
  }

  descargar (id: string) {
    window.open(`https://viteri-api.ceslyweb.com/pedidos/download?id=${id}`, '_blank')
  }

  descargarPdf (id: string) {
    window.open(`https://viteri-api.ceslyweb.com/pedidos/pdf/${id}`, '_blank')
  }

  descargarTodos () {
    window.open('https://viteri-api.ceslyweb.com/pedidos/download', '_blank')
  }

  verDetalle (id: string) {
    pedidos.fetchDetails(id).finally(() => {
      this.openDetalle = true
    })
  }

  filtrarPedidos () {
    pedidos.fetchAll({ start: this.desde, end: this.hasta })
  }

  mounted () {
    pedidos.fetchAll({ start: this.desde, end: this.hasta })
  }
}
